import { useEffect } from 'react';
import { withCompController } from '@wix/editor-elements-integrations';
import type {
  ILoginSocialBarControllerProps,
  ILoginSocialBarMapperProps,
  ILoginSocialBarProps,
  ILoginSocialBarStateValues,
} from '../LoginSocialBar.types';
import { resolveMemberDetails } from '../../../core/commons/controllerUtils';

export default withCompController<
  ILoginSocialBarMapperProps,
  ILoginSocialBarControllerProps,
  ILoginSocialBarProps,
  ILoginSocialBarStateValues
>(({ mapperProps, controllerUtils, stateValues }) => {
  const { loginSocialBarEnableUrlChangeListeners } = mapperProps;
  const { updateProps } = controllerUtils;
  const {
    reportBi,
    currentUrl,
    navigateTo,
    addOnUrlChangeListener,
    removeOnUrlChangeListener,
    getMemberDetails,
    logout,
    promptLogin,
    registerToUserLogin,
    registerToMemberDetailsRefresh,
    unRegisterToUserLogin,
    unRegisterToMemberDetailsRefresh,
  } = stateValues;

  useEffect(() => {
    const updateMemberDetails = () => {
      resolveMemberDetails(getMemberDetails).then(memberDetails => {
        updateProps({ ...memberDetails });
      });
    };

    const onLoginCallbackId = registerToUserLogin(updateMemberDetails);
    const onMemberDetailsRefreshCallbackId =
      registerToMemberDetailsRefresh(updateMemberDetails);
    const onUrlChangeListener = { onUrlChange: updateMemberDetails };

    if (loginSocialBarEnableUrlChangeListeners) {
      addOnUrlChangeListener(onUrlChangeListener);
    }

    updateMemberDetails();

    return () => {
      unRegisterToUserLogin(onLoginCallbackId);
      unRegisterToMemberDetailsRefresh(onMemberDetailsRefreshCallbackId);

      if (loginSocialBarEnableUrlChangeListeners) {
        removeOnUrlChangeListener(onUrlChangeListener);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    ...mapperProps,
    onMenuOpen: () => {
      updateProps({
        isMenuOpen: true,
      });
    },
    onMenuClose: () => {
      updateProps({
        isMenuOpen: false,
      });
    },
    reportBi,
    currentPrimaryPageHref: currentUrl,
    navigateTo,
    onLogout: () => {
      logout();
    },
    onLogin: () => {
      promptLogin();
    },
  };
});
